import axios from "axios";
import Session from "../Session/Session";

export const GenerateTokken = async (api: string) => {
  return axios
    .post(
      api,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          username: "broker@evervent.in",
          password: "123456",
        },
      }
    )
    .then((res) => {
      // handle success

      let results = res.data;
      let status = results.status;
      let message = results.message;
      let response = results.data;

      if (status === "failed") {
        alert(message);
      }
      return [status, response];
    })
    .catch((error) => {
      return [error, {}];
    });
};

export const Post = async (api: string, params: {}) => {
  let access_token = localStorage.getItem("access_tokken");
  let user_token = localStorage.getItem("usertoken");

  var header_data = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Token": access_token,
    auth: user_token,
  };

  return axios
    .post(api, params, {
      headers: header_data,
    })
    .then((res) => {
      // handle success

      let results = res.data;
      let status = results.status;
      let message = results.message;
      let response = results.data;

      if (status === "failed") {
        alert(message);
      }

      console.log(results);
      return [status, response];
    })
    .catch((error) => {
      alert(error);
      return [error, {}];
    });
};

export const Get = async (api: string) => {
  var header_data = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization:
      "Bearer " +
      (Session.getTokken().length == 0
        ? "createNewToken"
        : Session.getTokken()),
  };

  return axios

    .get(api, {
      headers: header_data,
    })

    .then((res) => {
      // handle success

      let results = res.data;
      let error = results.error;
      let message = results.message;
      let response = results.response;

      if (error === true) {
        alert(message);
      }

      return [error, response];
    })

    .catch((error) => {
      alert(error);

      return [error, {}];
    });
};
